
import bildEinfamilienhaus from '@/assets/icons/gebaeudetyp_einzelhaus.svg';
import bildMehrfamilienhaus from '@/assets/icons/gebaeudetyp_mehrfamilienhaus.svg';
import bildReihenendhaus from '@/assets/icons/gebaeudetyp_reihenendhaus.svg';
import bildReihenmittelhaus from '@/assets/icons/gebaeudetyp_reihenmittelhaus.svg';
import bildDoppelhaus from '@/assets/icons/gebaeudetyp_doppelhaushaelfte.svg';

export const buildingTypes = [
    { name: 'Freistehendes Einzelhaus', available: true, value: 'einfamilienhaus', api: '19762', image: bildEinfamilienhaus },
    { name: 'Doppelhaushälfte', available: true, value: 'doppelhaus', api: '19763',  image: bildDoppelhaus },
    { name: 'Reihenmittelhaus', available: true, value: 'reihenmittelhaus', api: '19764', image: bildReihenmittelhaus },
    { name: 'Reihenendhaus', available: true,  value: 'reihenendhaus', api: '20273', image: bildReihenendhaus },
    { name: 'Mehrfamilienhaus', available: false,  value: 'mehrfamilienhaus', api: '19765', image: bildMehrfamilienhaus },
];

export const buildingTypesApi = {parameter: '17053', type: 'value_choice'}

